import React from 'react';
import { useNavigate } from 'react-router-dom';

const ServiceCard = ({ service, onBookClick }) => {
  const navigate = useNavigate();

  const handleBookClick = () => {
    if (service.isrelatedtofood) {
      navigate('/dashboard/core-modules/f&b-management/order-food');
    } else {
      onBookClick(service);
    }
  };

  return (
    <div className="relative bg-white rounded-lg shadow-md overflow-hidden flex flex-col">
      {/* Availability Badge (Top-Right) */}
      <span
        className={`absolute top-3 right-3 px-3 py-1 text-sm font-semibold rounded-full ${
          service.isactive ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
        }`}
      >
        {service.isactive ? 'Available' : 'Unavailable'}
      </span>

      {/* Image */}
      <div className="h-72 overflow-hidden">
        <img src={service.imageurl} alt={service.name} className="w-full h-full object-cover" />
      </div>

      {/* Card Content */}
      <div className="flex flex-col flex-grow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">{service.name}</h2>
        <p className="text-gray-600 mb-4 flex-grow">{service.description}</p>

        {/* Booking Button */}
        <button
          onClick={handleBookClick}
          disabled={!service.isactive}
          className={`w-full mt-auto py-2 px-4 rounded-md transition duration-300 ${
            service.isactive
              ? 'bg-black text-white font-semibold hover:text-gray-300'
              : 'bg-gray-400 text-gray-700 font-semibold cursor-not-allowed'
          }`}
        >
          Book Service
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;
